import Icon from '../components/Icon.vue'

Icon.register({
  'mobile-alt': {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M272 0c26.5 0 48 21.5 48 48v416c0 26.5-21.5 48-48 48h-224c-26.5 0-48-21.5-48-48v-416c0-26.5 21.5-48 48-48h224zM160 480c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zM272 372v-312c0-6.6-5.4-12-12-12h-200c-6.6 0-12 5.4-12 12v312c0 6.6 5.4 12 12 12h200c6.6 0 12-5.4 12-12z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/mobile-alt.js
// module id = 1575
// module chunks = 0